import React from 'react'

import RegisterUserForm from '../RegisterUserForm/RegisterUserForm'
import RolePicker from '../../pickers/RolePicker/RolePicker'
import LocationPicker from '../../pickers/LocationPicker/LocationPicker'
import './CreateUserForm.css'

function CreateUserForm ({ user, setUser, handleChange, options, action }) {
  function onChange (e) {
    setUser({ ...user, role: e.target.value })
  }

  return (
    <div className='form container-fluid'>
      <div className='form-floating'>
        <input
          name='email'
          type='email'
          className='form-control'
          id='floatingEmail'
          placeholder='email'
          value={user.email}
          onChange={handleChange}
          required
          disabled={action !== 'create' && user && user.email}
        />
        <label htmlFor='floatingEmail'>Email</label>
      </div>

      <RegisterUserForm
        user={user}
        handleChange={handleChange}
      />

      <div className='form-floating'>
        <RolePicker value={user.role} onChange={onChange} />
      </div>
      <div className='form-floating'>
        <LocationPicker values={user.location ?? []} setUser={setUser} options={options} />
      </div>
    </div>

  )
}

export default CreateUserForm
